import aT from '../const/action-type'

export default (data) => {
  return { type: aT.ADD_FRESH, data }
}
